import { useState } from "react";
import { Link } from "@tanstack/react-router";
import { track } from "@/lib/analytics";
import {
  SERIES_COLLECTIONS,
  type SeriesCollection,
} from "@/lib/series-collections";

function CollectionTile({ collection }: { collection: SeriesCollection }) {
  const [logoFailed, setLogoFailed] = useState(false);
  const showLogo = collection.logo && !logoFailed;

  return (
    <Link
      to="/schedule/$collectionKey"
      params={{ collectionKey: collection.key }}
      className="collection-tile"
      onClick={() =>
        track("tr_home_collection_click", { collection: collection.key })
      }
    >
      {showLogo ? (
        <>
          <img
            src={collection.logo}
            alt={collection.label}
            className="collection-tile-logo"
            onError={() => setLogoFailed(true)}
          />
          <span className="collection-tile-label">{collection.label}</span>
        </>
      ) : (
        <span className="collection-tile-fallback">{collection.label}</span>
      )}
    </Link>
  );
}

export function SeriesCollectionGrid() {
  return (
    <section className="home-collections" aria-label="Browse event series">
      <div className="home-collections-heading">Browse by series</div>
      <div className="home-collections-grid">
        {SERIES_COLLECTIONS.map((collection) => (
          <CollectionTile key={collection.key} collection={collection} />
        ))}
      </div>
    </section>
  );
}
